module.exports = __webpack_public_path__ + "img/stomach.c8c38a4a.svg";